import React, { useState, useEffect } from "react";
import {
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  CardHeader,
  Button,
  CardBody,
} from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { injectIntl } from "react-intl";
import classnames from "classnames";
import { Separator } from "../../components/common/CustomBootstrap";import createSocket from "../../helpers/createSocket";
import { END_POINT, END_POINT_SOCKET } from "../../constants/defaultValues";
import {
  AddCommaNumber,
  NotificatioErrController,
  NotificatioSucController,
} from "../../helpers/Utils";
import PerfectScrollbar from "react-perfect-scrollbar";
import { DateRangePicker } from "../../components/common/DateRangePicker";
import axios from "axios";
import moment from "moment";
import LogsHelper from "../../helpers/Logs";
import ProductImage from "../../components/common/ProductImage";

const getWidth = () =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

function useCurrentWitdh() {
  // save current window width in the state object
  let [width, setWidth] = useState(getWidth());

  // in this case useEffect will execute only once because
  // it does not have any dependencies.
  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => setWidth(getWidth()), 150);
    };
    // set resize listener
    window.addEventListener("resize", resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return width;
}

const OrderHistoryModal = ({
  isOpen,
  toggle,
  intl,
  // dataOrderHistory,
  // reOrders,
  // onCancelOrderHistory
}) => {
  const [socket, setSocket] = useState(null);

  //Dùng useEffect để quản lý vòng đời của socket
  useEffect(() => {
    // Kết nối socket chỉ một lần khi component được mount
    const newSocket = createSocket();
    setSocket(newSocket); // Lưu instance của socket vào state

    // 3. Trả về một cleanup function để ngắt kết nối khi component unmount
    return () => {
      newSocket.disconnect();
    };
  }, []);

  // Effect để join room, sẽ chạy sau khi socket đã được kết nối thành công
  useEffect(() => {
    // Chỉ thực hiện khi socket đã được khởi tạo
    if (socket) {
      socket.emit("join room", {
        room_id: localStorage.getItem("user_id"),
      });

      socket.emit("join room", {
        room_id: localStorage.getItem("b"),
      });
    }
  }, [socket]);

  let width = useCurrentWitdh();
  const isMobile = width <= 980;

  useEffect(() => {
    fetchOrdersByDate();
    setToggleCalendar(false);
  }, []);

  // State để lưu khoảng ngày được chọn từ date picker
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  // State để lưu danh sách order lấy từ API
  const [data, setData] = useState({ orders: [] });
  // State để quản lý trạng thái loading và lỗi
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [toggleCalendar, setToggleCalendar] = useState(false);

  const handleToggleCalendar = () => {
    setToggleCalendar(!toggleCalendar);
  };

  // Hàm gọi API để lấy order theo khoảng ngày
  const fetchOrdersByDate = async (shouldNotToggle = false) => {
    // Nếu chưa chọn ngày thì không làm gì
    if (!dateRange.startDate || !dateRange.endDate) {
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    setData({ orders: [] }); // Xóa dữ liệu cũ trước khi tìm kiếm
    if (!shouldNotToggle) {
      setToggleCalendar(false);
    }

    try {
      const tokenStr = localStorage.getItem("access_token");

      const startDate = moment(dateRange.startDate).format("YYYY-MM-DD");
      const endDate = moment(dateRange.endDate).format("YYYY-MM-DD");

      axios
        .get(
          `${
            END_POINT + "/order/order-history"
          }?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          },
        )
        .then((res) => {
          return res.data;
        })
        .then(async (data) => {
          if (data) {
            setData({ orders: data.data });
          } else {
            NotificatioErrController(<IntlMessages id="home.history.empty" />);
          }
        })
        .catch((err) => {
          const message = err?.response?.data?.responseText || err.message || "Lỗi hệ thống";
          NotificatioErrController(message);
        });
    } catch (err) {
      console.error("Lỗi khi lấy dữ liệu order:", err);
      setError(<IntlMessages id="home.history.error" />);
    } finally {
      setLoading(false);
    }
  };

  const onReturnOrder = (orderId) => () => {
    // eslint-disable-next-line no-restricted-globals
    if (
      window.confirm(intl.formatMessage({ id: "home.history.confirm-return" }))
    ) {
      const tokenStr = localStorage.getItem("access_token");
      axios
        .delete(`${END_POINT + "/order/return-order"}`, {
          data: { orderId },
          headers: { Authorization: `Bearer ${tokenStr}` },
        })
        .then((res) => {
          NotificatioSucController(
            intl.formatMessage({ id: "home.history.return-success" }),
          );

          // 1. Refresh local list in modal
          fetchOrdersByDate(true);

          // 2. Emit socket events for real-time update
          if (socket) {
            const userId = localStorage.getItem("user_id");
            const parentId = localStorage.getItem("b") || userId;

            // Helper to emit to both user and parent rooms to ensure everyone is updated
            const emitRefresh = (event, payload) => {
              socket.emit(event, { user_id: userId, ...payload });
              if (parentId !== userId) {
                socket.emit(event, { user_id: parentId, ...payload });
              }
            };

            emitRefresh("refresh-done-order", {});
            emitRefresh("refresh-stock", {});
            emitRefresh("refresh-pending-order", {});
            emitRefresh("refresh-recent-order", {});
            emitRefresh("refresh-refund-order", {});

            socket.emit("create logs", {
              user_id: userId,
              message: LogsHelper["order-return"],
            });
          }
        })
        .catch((err) => {
          NotificatioErrController(err?.response?.data?.responseText);
        });
    }
  };

  const renderDateText = () => {
    const start = moment(dateRange.startDate);
    const end = moment(dateRange.endDate);
    const today = moment();

    const isSingleDay = start.isSame(end, "day");
    const isToday = start.isSame(today, "day");

    if (isSingleDay && isToday) {
      return `Hôm nay, ${today.format("DD/MM/YYYY")}`;
    }

    // Nếu chỉ chọn một ngày nhưng không phải hôm nay
    if (isSingleDay) {
      return `Ngày: ${start.format("DD/MM/YYYY")}`;
    }

    // Nếu chọn khoảng ngày
    return `Khoảng ngày: ${start.format("DD/MM/YYYY")} - ${end.format(
      "DD/MM/YYYY",
    )}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      // className={classnames("table-modal cursor-pointer", {
      //   "table-bill-desktop": !isMobile,
      // })}
      wrapClassName="modal-right modal-right-order-history"
      backdrop={true}
    >
      <ModalHeader toggle={toggle}>
        <IntlMessages id="home.history.title" />
      </ModalHeader>
      <ModalBody
        style={{
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          padding: isMobile ? "10px" : "15px",
        }}
      >
        <div style={{ position: "relative", flexShrink: 0 }}>
          <a
            className="d-flex justify-content-center align-items-center theme-button"
            onClick={handleToggleCalendar}
            style={{ padding: isMobile ? "8px" : "10px" }}
          >
            {" "}
            <i className="simple-icon-calendar mr-2" />{" "}
            <span
              className={isMobile ? "text-small" : "text-one mr-3 d-none d-md-flex"}
              style={{ fontSize: isMobile ? "0.8rem" : undefined }}
            >
              {renderDateText()}
            </span>{" "}
            <i
              className={`simple-icon-arrow-${toggleCalendar ? "up" : "down"} text-small`}
            />{" "}
          </a>
          {toggleCalendar && (
            <div
              className="calendar-mobile-wrapper"
              style={{
                position: isMobile ? "fixed" : "absolute",
                top: isMobile ? "0" : "100%",
                left: 0,
                right: 0,
                bottom: isMobile ? 0 : "auto",
                zIndex: 1051,
                backgroundColor: isMobile ? "rgba(255,255,255,0.98)" : "#fff",
                boxShadow: isMobile ? "none" : "0 8px 24px rgba(0,0,0,0.2)",
                borderRadius: isMobile ? "0" : "8px",
                padding: isMobile ? "0" : "16px",
                maxHeight: isMobile ? "100vh" : "none",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className="custom-daterange__container"
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="date-label mb-2" style={{ width: "100%" }}>
                  <DateRangePicker
                    initialDateRange={dateRange}
                    open={toggleCalendar}
                    onChange={setDateRange}
                    definedRanges={[
                      {
                        label: <IntlMessages id="analytics.today" />,
                        startDate: moment(),
                        endDate: moment(),
                      },
                      {
                        label: <IntlMessages id="analytics.yesterday" />,
                        startDate: moment().subtract(1, "days"),
                        endDate: moment().subtract(1, "days"),
                      },
                      {
                        label: <IntlMessages id="analytics.7-days-ago" />,
                        startDate: moment().subtract(6, "days"),
                        endDate: moment(),
                      },
                      {
                        label: <IntlMessages id="analytics.this-week" />,
                        startDate: moment().startOf("isoWeeks"),
                        endDate: moment().endOf("isoWeeks"),
                      },
                      {
                        label: <IntlMessages id="analytics.last-week" />,
                        startDate: moment()
                          .subtract(1, "weeks")
                          .startOf("isoWeeks"),
                        endDate: moment()
                          .subtract(1, "weeks")
                          .endOf("isoWeeks"),
                      },
                      {
                        label: <IntlMessages id="analytics.30-days-ago" />,
                        startDate: moment().subtract(30, "days"),
                        endDate: moment().subtract(1, "days"),
                      },
                      {
                        label: <IntlMessages id="analytics.this-month" />,
                        startDate: moment().startOf("months"),
                        endDate: moment(),
                      },
                      {
                        label: <IntlMessages id="analytics.last-month" />,
                        startDate: moment()
                          .subtract(1, "months")
                          .startOf("months"),
                        endDate: moment().subtract(1, "months").endOf("months"),
                      },
                      {
                        label: <IntlMessages id="analytics.all" />,
                        startDate: moment().add(1, "days"),
                        endDate: moment().add(1, "days"),
                      },
                    ]}
                  />
                </div>
              </div>
              <div
                className={isMobile ? "px-3 pb-4 mt-2 text-center" : "mt-2 text-center"}
                style={{ flexShrink: 0, position: "relative", zIndex: 2 }}
              >
                <Button
                  color="primary"
                  block
                  size={isMobile ? "md" : "md"}
                  onClick={() => fetchOrdersByDate()}
                  disabled={loading}
                  style={{ borderRadius: isMobile ? "0" : "20px" }}
                >
                  <IntlMessages id="home.history.search" />
                </Button>
                {isMobile && (
                  <Button
                    color="link"
                    size="sm"
                    className="mt-2 text-muted"
                    onClick={() => setToggleCalendar(false)}
                  >
                    Đóng
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
        <hr className="my-2" style={{ flexShrink: 0, width: "100%" }} />

        {/* Khu vực hiển thị kết quả */}
        <PerfectScrollbar
          style={{ flex: 1 }}
          options={{
            suppressScrollX: true,
            wheelPropagation: true,
          }}
        >
          <div className="order-results px-1">
            {loading && (
              <div className="text-center p-4">
                <IntlMessages id="home.history.loading" />
              </div>
            )}

            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && !error && data?.orders?.length === 0 && (
              <div className="text-center p-4 text-muted">
                <IntlMessages id="home.history.empty" />
              </div>
            )}

            {Object.keys(data?.orders).map((pin, idx) => (
              <Card key={idx} className="mb-2 mt-2 shadow-sm border-0">
                <CardBody className={isMobile ? "p-2" : "p-3"}>
                  <p className="mb-2 font-weight-bold" style={{ fontSize: isMobile ? "0.85rem" : "1rem" }}>
                    <IntlMessages id="home.history.invoice" />: #{pin}
                  </p>
                  {data.orders[pin].map((order) => (
                    <div
                      className="d-flex flex-row mb-3 p-2 border-radius-10px"
                      style={{
                        backgroundColor: "rgba(128, 128, 128, 0.05)",
                        gap: "12px",
                        border: "1px solid #f0f0f0",
                      }}
                      key={order?.id}
                    >
                      {/* 1. Rectangular Image (4:3 ratio) on Left */}
                      <div className="d-block position-relative flex-shrink-0">
                        <ProductImage
                          image={order?.product?.image}
                          alt={order?.product?.name}
                          fnbType={order?.product?.fnb_type}
                          className="border-0"
                          style={{
                            width: isMobile ? "110px" : "130px",
                            height: isMobile ? "82px" : "97px", // Maintain 4:3 aspect ratio
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                          iconSize="40px"
                        />
                      </div>

                      {/* 2. Content on Right */}
                      <div className="d-flex flex-column flex-grow-1 min-width-zero">
                        {/* Row 1: Name & Return Button */}
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <span
                            className="list-item-heading mb-0"
                            style={{
                              fontSize: isMobile ? "0.9rem" : "1rem",
                              fontWeight: "600",
                              flex: 1,
                              lineHeight: "1.2",
                              color: "#333",
                              paddingRight: "10px",
                            }}
                          >
                            {order?.product?.name}
                          </span>
                          <Button
                            onClick={onReturnOrder(order.id)}
                            color="warning"
                            size="sm"
                            className="btn-xs px-2"
                            style={{
                              fontSize: "0.65rem",
                              height: "24px",
                              flexShrink: 0,
                            }}
                          >
                            <IntlMessages id="home.history.btn-return" />
                          </Button>
                        </div>

                        {/* Row 2: Price (Normal Text) */}
                        <div
                          className="font-weight-bold text-primary mb-1"
                          style={{ fontSize: isMobile ? "0.85rem" : "0.95rem" }}
                        >
                          {AddCommaNumber(order?.price)} đ
                        </div>

                        {/* Row 3: SKU & Info */}
                        <div
                          className="text-muted mt-auto"
                          style={{ fontSize: "0.7rem", lineHeight: "1.4" }}
                        >
                          <div>
                            <span className="font-weight-bold">SKU:</span>{" "}
                            {order?.product?.sku || "N/A"}
                          </div>
                          <div>
                            <i className="simple-icon-clock mr-1" />
                            {order?.date} - {order?.time}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </CardBody>
              </Card>
            ))}
          </div>
        </PerfectScrollbar>
      </ModalBody>
      {/* <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                    Đóng
                    </Button>
                </ModalFooter> */}
    </Modal>
  );
};
export default injectIntl(OrderHistoryModal);
